/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
// this function is called on update and delete so adding additional expands once rather than changing 3 other files
// TODO: find a better way to only call for cartLines and properties when this is called in the mini-cart
export const XngExpandApiParameter: any = (props: any) => {
    const pageType = getCurrentPage(props.getState()).type;
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["validation"],
    };
    props.apiParameter.forceRecalculation = true;
    props.apiParameter.allowInvalidAddress = true;
    let xngExpand = ["cartLines", "restrictions", "properties"];
    if (props.parameter.fullExpand || pageType === "CheckoutReviewAndSubmitPage") {
        xngExpand = [...xngExpand, "shipping", "tax", "carriers", "paymentOptions"];
    }
    props.apiParameter.expand = [...(props.apiParameter.expand || []), ...xngExpand];
};

replaceInChain(chain, PopulateApiParameter, XngExpandApiParameter);
